import axios from "axios";
import {INBOUND_DRIVER_OFFICER_LIST_URL} from '../../config/stck.links'
import {toast} from 'react-toastify'

export const FETCH_INBOUND_DRIVER_OFFICER_LIST = 'FETCH_INBOUND_DRIVER_OFFICER_LIST'
export const RECEIVE_INBOUND_DRIVER_OFFICER_LIST = 'RECEIVE_INBOUND_DRIVER_OFFICER_LIST'
export const FAILED_INBOUND_DRIVER_OFFICER_LIST = 'FAILED_INBOUND_DRIVER_OFFICER_LIST'

export function fetchInboundDriverOfficer(_idMasterInbound=null, _idInboundDetail=null){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_INBOUND_DRIVER_OFFICER_LIST});
        axios({
            method: 'post',
            url: INBOUND_DRIVER_OFFICER_LIST_URL,
            headers: {
                Authorization: auth
            },
            data:{
                id_master_inbound: _idMasterInbound,
                id_inbound_detail: _idInboundDetail
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_INBOUND_DRIVER_OFFICER_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_INBOUND_DRIVER_OFFICER_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_INBOUND_DRIVER_OFFICER_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_INBOUND_DRIVER_OFFICER_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_INBOUND_DRIVER_OFFICER_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_INBOUND_DRIVER_OFFICER_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_INBOUND_DRIVER_OFFICER_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}